
// // 100단위 한글 포맷: 예) 3500 -> "3천 5백"
// export const formatAmountHundredsKo = (amount: number): string => {
//     if (!Number.isFinite(amount)) return "";

//     const isNegative = amount < 0;
//     // 최소 단위를 100으로 고정 (100 미만은 버림)
//     const absHundreds = Math.floor(Math.abs(amount) / 100) * 100;
//     if (absHundreds === 0) return "0";

//     const parts: string[] = [];

//     // 억 단위 (100,000,000)
//     const EOK = 100_000_000;
//     const MAN = 10_000;

//     let remainder = absHundreds;

//     const eok = Math.floor(remainder / EOK);
//     remainder = remainder % EOK;
//     if (eok > 0) {
//         const chunk = formatChunkThousandsHundreds(eok);
//         parts.push(chunk ? `${chunk}억` : `${eok}억`);
//     }

//     const man = Math.floor(remainder / MAN);
//     remainder = remainder % MAN;
//     if (man > 0) {
//         const chunk = formatChunkThousandsHundreds(man);
//         parts.push(chunk ? `${chunk}만` : `${man}만`);
//     }

//     const lower = formatChunkThousandsHundreds(remainder);
//     if (lower) parts.push(lower);

//     const result = parts.join(" ");
//     return isNegative ? `-${result}` : result;
// };

// function formatChunkThousandsHundreds(n: number): string {
//     const parts: string[] = [];
//     const thousands = Math.floor(n / 1000);
//     const hundreds = Math.floor((n % 1000) / 100);

//     if (thousands > 0) parts.push(`${thousands}천`);
//     if (hundreds > 0) parts.push(`${hundreds}백`);

//     return parts.join(" ");
// }

// 입력 단위: "만원". 예) 10000(만원) -> "1억", 15000(만원) -> "1억 5천만원"
export const formatAmountManKo = (amountMan: number): string => {
    if (!Number.isFinite(amountMan)) return "";

    const isNegative = amountMan < 0;
    const abs = Math.floor(Math.abs(amountMan));
    if (abs === 0) return "0만원";

    const parts: string[] = [];

    const EOK_IN_MAN = 10_000; // 1억 = 10000만원

    const eok = Math.floor(abs / EOK_IN_MAN);
    const remainderMan = abs % EOK_IN_MAN;

    if (eok > 0) parts.push(`${eok}억`);

    // 항상 만원 단위 표기하되, 정확히 억 단위(나머지 0)면 0만원은 생략
    if (remainderMan > 0 || eok === 0) {
        const formatter = new Intl.NumberFormat("ko-KR");
        const remainderStr = `${formatter.format(remainderMan)}만원`;
        parts.push(remainderStr);
    }

    const result = parts.join(" ");
    return isNegative ? `-${result}` : result;
};

// 총액(만원)이 10 미만일 때는 천원(0.1만원) 단위까지 표기
// - 예) 1.2만원 -> "1만원 2천원", 0.2만원 -> "2천원"
// - 총액이 10만원 이상이면 기존 만원 표기 유지
export const formatAmountAdaptiveKo = (
    amountMan: number,
    useThousandUnit: boolean
): string => {
    if (!Number.isFinite(amountMan)) return "";

    const isNegative = amountMan < 0;
    const abs = Math.abs(amountMan);

    if (!useThousandUnit) {
        return formatAmountManKo(amountMan);
    }

    // 천원 표기: 만원 정수부 + (있으면) 천원부
    let wholeMan = Math.floor(abs); // 만원 정수부
    let thousandPart = Math.round(((abs - wholeMan) * 10) + 1e-8); // 0~9 천원 단위 (부동소수 보정용)
    if (thousandPart === 10) {
        wholeMan += 1;
        thousandPart = 0;
    }

    const parts: string[] = [];
    const formatter = new Intl.NumberFormat("ko-KR");
    if (wholeMan > 0 && thousandPart > 0) {
        parts.push(`${formatter.format(wholeMan)}만`);
    } else if (wholeMan > 0) {
        parts.push(`${formatter.format(wholeMan)}만원`);
    }
    if (thousandPart > 0) {
        parts.push(`${formatter.format(thousandPart)}천원`);
    }

    if (parts.length === 0) return "0원";
    const result = parts.join(" ");
    return isNegative ? `-${result}` : result;
};

export const isNumberInvalid = (v: number | null | undefined) =>
    v === null || v === undefined || Number.isNaN(v) || v <= 0;

// formatManRemainder: 이전 상세 한글 표기 로직은 요구사항 변경으로 미사용


// timing "within_3y" 에서 3 -> 12 * 3 = 36
export const yearKeyToMonth = (timing: string) => {
    // 
    if (!timing) return 0;
    const numberString = timing.replace(/[^0-9]/g, "");
    const number = parseInt(numberString);
    return number * 12;
};

export const yearKeyToYear = (timing: string) => {
    if (!timing) return 0;
    const numberString = timing.replace(/[^0-9]/g, "");
    const number = parseInt(numberString);
    return number;
};


// 정수 총액을 가중치 비율에 따라 배분하되, 합계를 정확히 보존하는 함수
// (Largest Remainder / Hamilton 방식)
export function allocateIntegerByWeights(total: number, weights: number[]): number[] {
    const normalizedWeights = weights.map((w) =>
        Number.isFinite(w) && w > 0 ? Number(w) : 0
    );
    const count = normalizedWeights.length;
    if (count === 0) return [];

    const sumWeights = normalizedWeights.reduce((acc, v) => acc + v, 0);

    // 가중치 합이 0이면 첫 번째 항목에 전부 배정(보여주기 위해 합계만 맞춤)
    if (sumWeights <= 0) {
        const result = new Array(count).fill(0);
        result[0] = Math.max(0, Math.floor(total));
        return result;
    }

    const exactQuotas = normalizedWeights.map((w) => (w / sumWeights) * total);
    const floors = exactQuotas.map((q) => Math.floor(q));
    let remainder = Math.max(
        0,
        Math.floor(total) - floors.reduce((acc, v) => acc + v, 0)
    );

    // 나머지 배분: 소수부분이 큰 순서, 동률이면 원 가중치가 큰 순서, 그래도 동률이면 앞 인덱스 우선
    const indices = exactQuotas
        .map((q, idx) => ({
            idx,
            frac: q - Math.floor(q),
            w: normalizedWeights[idx],
        }))
        .sort((a, b) => {
            if (b.frac !== a.frac) return b.frac - a.frac;
            if (b.w !== a.w) return b.w - a.w;
            return a.idx - b.idx;
        })
        .map((d) => d.idx);

    for (let i = 0; i < remainder; i++) {
        floors[indices[i]] += 1;
    }

    return floors;
}


// 자산군명 변환
export const convertAssetGroupNm = (assetGroupNm: string) => {
    switch (assetGroupNm) {
        case "대체자산":
            return "금";
        case "유동성":
            return "현금";
        default:
            return assetGroupNm;
    }
}